export var ChartType;
(function (ChartType) {
    ChartType["Line"] = "Line";
    ChartType["Pie"] = "Pie";
    ChartType["Bar"] = "Bar";
    ChartType["MultiLine"] = "multiline";
    ChartType["Doughnut"] = "Doughnut";
    ChartType["Scatter"] = "Scatter";
})(ChartType || (ChartType = {}));
export var ViewType;
(function (ViewType) {
    ViewType[ViewType["Kanban"] = 0] = "Kanban";
    ViewType[ViewType["Timeline"] = 1] = "Timeline";
    ViewType[ViewType["Calendar"] = 2] = "Calendar";
    ViewType[ViewType["Reporting"] = 3] = "Reporting";
    ViewType[ViewType["Card"] = 4] = "Card";
    ViewType[ViewType["Gantt"] = 5] = "Gantt";
    ViewType[ViewType["RowDisplay"] = 6] = "RowDisplay";
})(ViewType || (ViewType = {}));
export var AlignMent;
(function (AlignMent) {
    AlignMent[AlignMent["Left"] = 0] = "Left";
    AlignMent[AlignMent["Center"] = 1] = "Center";
    AlignMent[AlignMent["Right"] = 2] = "Right";
})(AlignMent || (AlignMent = {}));
export const isChartCOnfig = (object) => {
    return 'chatconfigtype' in object;
};
export var FilterOp;
(function (FilterOp) {
    FilterOp["Eq"] = "Equal";
    FilterOp["LTE"] = "Less than equal";
    FilterOp["GTE"] = "Greater than equal";
    FilterOp["GT"] = "Greater than";
    FilterOp["LT"] = "Less than";
    FilterOp["In"] = "IN";
    FilterOp["NotIn"] = "Not IN";
    FilterOp["NEq"] = "Not Equal";
})(FilterOp || (FilterOp = {}));
